(function () {
  'use strict';

  /* ── Announcement bar rotator ── */
  function initAnnouncementBars(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const bars = scope === document
      ? document.querySelectorAll('[data-announcement]')
      : scope.querySelectorAll('[data-announcement]');

    bars.forEach(bar => {
      if (bar.dataset.announcementInit === 'true') return;
      bar.dataset.announcementInit = 'true';

      if (bar.classList.contains('announcement-bar--scroll')) {
        const speed = parseInt(bar.dataset.speed, 10) || 4;
        const track = bar.querySelector('.announcement-bar__track');
        if (!track) return;

        track.style.setProperty('--marquee-duration', `${Math.max(speed * 3, 18)}s`);

        const getMessages = () => {
          if (!track.dataset.sourceMessages) {
            const messages = [...track.querySelectorAll('.announcement-bar__item')]
              .map(item => item.textContent.trim())
              .filter(Boolean);
            track.dataset.sourceMessages = JSON.stringify(messages);
          }
          return JSON.parse(track.dataset.sourceMessages || '[]');
        };

        const appendMessageSet = messages => {
          messages.forEach(text => {
            const item = document.createElement('span');
            item.className = 'announcement-bar__item';
            item.textContent = text;
            track.appendChild(item);
          });
        };

        const buildScrollLoop = () => {
          const messages = getMessages();
          if (!messages.length) return;

          track.innerHTML = '';
          const barWidth = bar.offsetWidth || window.innerWidth;
          let guard = 0;

          while (track.scrollWidth < barWidth && guard < 24) {
            appendMessageSet(messages);
            guard += 1;
          }

          if (track.scrollWidth < barWidth) {
            appendMessageSet(messages);
          }

          const halfHtml = track.innerHTML;
          track.innerHTML = halfHtml + halfHtml;
        };

        buildScrollLoop();

        if (!bar.dataset.scrollResizeBound) {
          bar.dataset.scrollResizeBound = 'true';
          let resizeTimer;
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(buildScrollLoop, 150);
          });
        }

        return;
      }

      const rotator = bar.querySelector('[data-announcement-rotator]');
      if (!rotator) return;

      const slides = [...rotator.querySelectorAll('.announcement-bar__slide')].filter(
        slide => slide.getAttribute('aria-hidden') !== 'true'
      );
      if (slides.length < 2) return;

      const stepCount = slides.length;
      const speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
      let index = 0;
      let timer = null;

      const getStepHeight = () => slides[0]?.offsetHeight || 36;

      const goTo = (nextIndex, animate = true) => {
        rotator.style.transition = animate ? 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
        rotator.style.transform = `translateY(-${nextIndex * getStepHeight()}px)`;
        index = nextIndex;
      };

      const tick = () => {
        const next = index + 1;
        goTo(next, true);

        if (next >= stepCount) {
          window.setTimeout(() => {
            goTo(0, false);
          }, 460);
        }
      };

      const start = () => {
        clearInterval(timer);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(tick, speed);
      };

      bar.addEventListener('mouseenter', () => clearInterval(timer));
      bar.addEventListener('mouseleave', start);
      window.addEventListener('resize', () => goTo(index, false));
      start();
    });
  }

  initAnnouncementBars();

  document.addEventListener('shopify:section:load', event => {
    initAnnouncementBars(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-announcement]').forEach(bar => {
      delete bar.dataset.announcementInit;
      delete bar.dataset.scrollResizeBound;
    });
  });

  /* ── Header nav dropdowns (Type 2 desktop) ── */
  function closeHeaderNavItems(items) {
    items.forEach(item => {
      item.classList.remove('is-open');
      item.querySelector(':scope > .header-nav__row [data-header-nav-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }

  function closeHeaderNavSiblings(item) {
    const parent = item.parentElement;
    if (!parent) return;
    closeHeaderNavItems(
      [...parent.children].filter(
        child =>
          child !== item &&
          (child.classList.contains('header-nav__item') || child.classList.contains('header-nav__subitem'))
      )
    );
  }

  function toggleHeaderNavItem(item) {
    if (!item) return;
    const willOpen = !item.classList.contains('is-open');
    closeHeaderNavSiblings(item);
    item.classList.toggle('is-open', willOpen);
    item.querySelector(':scope > .header-nav__row [data-header-nav-toggle]')?.setAttribute(
      'aria-expanded',
      willOpen ? 'true' : 'false'
    );
  }

  function initHeaderNav(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const navs = scope === document ? document.querySelectorAll('[data-header-nav]') : scope.querySelectorAll('[data-header-nav]');

    navs.forEach(nav => {
      if (nav.dataset.headerNavInit === 'true') return;
      nav.dataset.headerNavInit = 'true';

      nav.addEventListener('click', event => {
        const toggle = event.target.closest('[data-header-nav-toggle]');
        if (toggle && nav.contains(toggle)) {
          event.preventDefault();
          event.stopPropagation();
          toggleHeaderNavItem(toggle.closest('.header-nav__item, .header-nav__subitem'));
          return;
        }

        const link = event.target.closest('.header-nav__link, .header-nav__sublink');
        if (!link || !nav.contains(link)) return;

        const item = link.closest('.header-nav__item, .header-nav__subitem');
        if (
          item &&
          (item.classList.contains('header-nav__item--has-children') ||
            item.classList.contains('header-nav__subitem--has-children'))
        ) {
          event.preventDefault();
          event.stopPropagation();
          toggleHeaderNavItem(item);
        }
      });
    });
  }

  initHeaderNav();

  document.addEventListener('click', event => {
    if (event.target.closest('[data-header-nav]')) return;
    document.querySelectorAll('[data-header-nav] .is-open').forEach(item => {
      item.classList.remove('is-open');
      item.querySelector(':scope > .header-nav__row [data-header-nav-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-header-nav] .is-open').forEach(item => {
      item.classList.remove('is-open');
      item.querySelector(':scope > .header-nav__row [data-header-nav-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('shopify:section:load', event => {
    initHeaderNav(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-header-nav]').forEach(nav => {
      delete nav.dataset.headerNavInit;
    });
  });

  /* ── Menu drawer ── */
  const menuDrawer = document.querySelector('.menu-drawer');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuCloseButtons = document.querySelectorAll('[data-menu-close]');
  const MENU_ANIM_MS = 600;
  let menuCloseTimer = null;

  function openMenuDrawer() {
    if (!menuDrawer || menuDrawer.classList.contains('is-open') || menuDrawer.classList.contains('is-opening')) return;

    clearTimeout(menuCloseTimer);
    menuDrawer.classList.remove('is-closing');
    menuDrawer.classList.add('is-opening');
    menuDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Force browser to paint closed state before opening
    void menuDrawer.offsetHeight;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        menuDrawer.classList.add('is-open');
        menuDrawer.classList.remove('is-opening');
      });
    });
  }

  function closeMenuDrawer() {
    if (!menuDrawer || !menuDrawer.classList.contains('is-open') || menuDrawer.classList.contains('is-closing')) return;

    menuDrawer.classList.remove('is-open');
    menuDrawer.classList.add('is-closing');
    menuDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    clearTimeout(menuCloseTimer);
    menuCloseTimer = setTimeout(() => {
      menuDrawer.classList.remove('is-closing');
    }, MENU_ANIM_MS);
  }

  menuToggle?.addEventListener('click', openMenuDrawer);
  menuCloseButtons.forEach(btn => btn.addEventListener('click', closeMenuDrawer));
  menuDrawer?.querySelector('.menu-drawer__overlay')?.addEventListener('click', closeMenuDrawer);

  menuDrawer?.addEventListener('click', e => {
    const toggle = e.target.closest('[data-menu-sub-toggle]');
    if (toggle) {
      e.preventDefault();
      const item = toggle.closest('.menu-drawer__item');
      if (!item) return;
      const isOpen = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    const link = e.target.closest('.menu-drawer__link');
    if (!link || !menuDrawer.classList.contains('is-open')) return;

    const item = link.closest('.menu-drawer__item');
    if (item?.classList.contains('menu-drawer__item--has-children')) return;

    closeMenuDrawer();
  });

  /* ── Cart drawer ── */
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartTriggers = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(el => el.addEventListener('click', e => {
    e.preventDefault();
    openCart();
  }));
  cartClose?.addEventListener('click', closeCart);
  cartDrawer?.querySelector('.cart-drawer__overlay')?.addEventListener('click', closeCart);

  /* ── Search modal + predictive search ── */
  const searchModal = document.querySelector('[data-search-modal]');
  const searchTriggers = document.querySelectorAll('[data-search-toggle]');
  const searchCloseButtons = document.querySelectorAll('[data-search-close]');
  const searchForm = searchModal?.querySelector('[data-search-form]');
  const searchInput = searchModal?.querySelector('[data-search-input]');
  const searchResults = searchModal?.querySelector('[data-search-results]');
  const searchEmpty = searchModal?.querySelector('[data-search-empty]');
  const searchStrings = window.theme?.search || {};
  const SEARCH_MIN_CHARS = 2;
  const SEARCH_DEBOUNCE_MS = 280;
  const SEARCH_LIMIT = parseInt(window.theme?.searchResultsLimit, 10) || 12;
  let searchDebounceTimer = null;
  let searchAbortController = null;

  function escapeHtml(str) {
    const el = document.createElement('div');
    el.textContent = str;
    return el.innerHTML;
  }

  function formatSearchPrice(price) {
    const cents = Math.round(parseFloat(String(price).replace(/[^0-9.]/g, '') || '0') * 100);
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function getSearchImage(item) {
    return item.featured_image?.url || item.image || '';
  }

  function showSearchEmptyState() {
    if (searchEmpty) searchEmpty.hidden = false;
    if (searchResults) {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
    }
    searchInput?.setAttribute('aria-expanded', 'false');
  }

  function hideSearchEmptyState() {
    if (searchEmpty) searchEmpty.hidden = true;
  }

  function clearSearchResults() {
    showSearchEmptyState();
  }

  function renderSearchProductCard(product) {
    const img = getSearchImage(product);
    const price = product.price_min || product.price;
    const compareAt = product.compare_at_price_min;
    const onSale = compareAt && parseFloat(compareAt) > parseFloat(price);
    const soldOut = product.available === false;
    const discount = onSale
      ? Math.round(((parseFloat(compareAt) - parseFloat(price)) / parseFloat(compareAt)) * 100)
      : 0;

    return `
      <a href="${product.url}" class="search-modal__product">
        <span class="search-modal__product-media">
          ${onSale ? `<span class="search-modal__product-badge search-modal__product-badge--sale">${discount}% OFF</span>` : ''}
          ${soldOut ? `<span class="search-modal__product-badge search-modal__product-badge--sold">${escapeHtml(searchStrings.soldOut || 'Sold out')}</span>` : ''}
          ${
            img
              ? `<img src="${img}" alt="${escapeHtml(product.title)}" width="320" height="320" loading="lazy">`
              : '<span class="search-modal__product-placeholder" aria-hidden="true"></span>'
          }
        </span>
        <span class="search-modal__product-body">
          <span class="search-modal__product-title">${escapeHtml(product.title)}</span>
          <span class="search-modal__product-price${onSale ? ' search-modal__product-price--sale' : ''}">
            ${formatSearchPrice(price)}${onSale ? `<s>${formatSearchPrice(compareAt)}</s>` : ''}
          </span>
        </span>
      </a>`;
  }

  function renderSearchResults(data, query) {
    if (!searchResults) return;

    const products = data?.resources?.results?.products || [];
    const collections = data?.resources?.results?.collections || [];

    hideSearchEmptyState();

    if (!products.length && !collections.length) {
      searchResults.innerHTML = `<p class="search-modal__message search-modal__message--empty">${escapeHtml(searchStrings.noResults || 'No results found')}</p>`;
      searchResults.hidden = false;
      searchInput?.setAttribute('aria-expanded', 'true');
      return;
    }

    const searchUrl = window.theme?.routes?.search_url || '/search';
    const countTemplate = searchStrings.productsCount || '{{ count }} products';
    const countLabel = countTemplate.replace('{{ count }}', String(products.length));
    let html = '<div class="search-modal__results-inner">';

    html += `
      <div class="search-modal__results-head">
        <p class="search-modal__results-count">${escapeHtml(countLabel)}</p>
        <a href="${searchUrl}?q=${encodeURIComponent(query)}" class="search-modal__results-view-all">${escapeHtml(searchStrings.viewAll || 'View all results for')} &ldquo;${escapeHtml(query)}&rdquo;</a>
      </div>`;

    if (collections.length) {
      html += `<div class="search-modal__collections"><p class="search-modal__collections-title">${escapeHtml(searchStrings.collectionsHeading || 'Collections')}</p><div class="search-modal__collections-list">`;
      collections.forEach(collection => {
        const img = getSearchImage(collection);
        html += `
          <a href="${collection.url}" class="search-modal__collection">
            ${img ? `<span class="search-modal__collection-thumb"><img src="${img}" alt="" width="48" height="48" loading="lazy"></span>` : ''}
            <span>${escapeHtml(collection.title)}</span>
          </a>`;
      });
      html += '</div></div>';
    }

    if (products.length) {
      html += `<div class="search-modal__grid">${products.map(renderSearchProductCard).join('')}</div>`;
    }

    html += '</div>';

    searchResults.innerHTML = html;
    searchResults.hidden = false;
    searchInput?.setAttribute('aria-expanded', 'true');
  }

  async function fetchPredictiveSearch(query) {
    if (!searchResults) return;

    searchAbortController?.abort();
    searchAbortController = new AbortController();

    hideSearchEmptyState();
    searchResults.innerHTML = `<p class="search-modal__message search-modal__message--loading"><span class="search-modal__spinner" aria-hidden="true"></span>${escapeHtml(searchStrings.loading || 'Searching...')}</p>`;
    searchResults.hidden = false;
    searchInput?.setAttribute('aria-expanded', 'true');

    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,collection',
      'resources[limit]': String(SEARCH_LIMIT),
      'resources[options][unavailable_products]': 'last'
    });

    const searchUrl = window.theme?.routes?.search_url || '/search';

    try {
      const res = await fetch(`${searchUrl}/suggest.json?${params.toString()}`, {
        signal: searchAbortController.signal
      });
      if (!res.ok) throw new Error('Search request failed');
      const data = await res.json();
      renderSearchResults(data, query);
    } catch (err) {
      if (err.name === 'AbortError') return;
      searchResults.innerHTML = `<p class="search-modal__message search-modal__message--empty">${escapeHtml(searchStrings.noResults || 'No results found')}</p>`;
    }
  }

  function onSearchInput() {
    const query = searchInput?.value.trim() || '';
    clearTimeout(searchDebounceTimer);

    if (query.length < SEARCH_MIN_CHARS) {
      searchAbortController?.abort();
      if (query.length === 0) {
        clearSearchResults();
      } else {
        hideSearchEmptyState();
        searchResults.innerHTML = `<p class="search-modal__message">${escapeHtml(searchStrings.typeToSearch || 'Type at least 2 characters to search')}</p>`;
        searchResults.hidden = false;
        searchInput?.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    searchDebounceTimer = setTimeout(() => fetchPredictiveSearch(query), SEARCH_DEBOUNCE_MS);
  }

  function openSearch() {
    searchModal?.classList.add('is-open');
    searchModal?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    showSearchEmptyState();
    setTimeout(() => searchInput?.focus(), 100);
  }

  function closeSearch() {
    searchModal?.classList.remove('is-open');
    searchModal?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    searchAbortController?.abort();
    clearTimeout(searchDebounceTimer);
    if (searchInput) searchInput.value = '';
    clearSearchResults();
  }

  searchTriggers.forEach(el => el.addEventListener('click', e => {
    e.preventDefault();
    openSearch();
  }));
  searchCloseButtons.forEach(btn => btn.addEventListener('click', closeSearch));
  searchModal?.querySelector('.search-modal__overlay')?.addEventListener('click', closeSearch);
  searchInput?.addEventListener('input', onSearchInput);
  searchForm?.addEventListener('submit', e => {
    const query = searchInput?.value.trim();
    if (!query) e.preventDefault();
  });

  document.addEventListener('click', e => {
    const suggestion = e.target.closest('[data-search-suggestion]');
    if (!suggestion || !searchModal?.contains(suggestion)) return;
    const term = suggestion.dataset.searchSuggestion || suggestion.textContent.trim();
    if (!searchInput || !term) return;
    searchInput.value = term;
    searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    searchInput.focus();
  });

  /* ── Collection tabs ── */
  document.querySelectorAll('[data-tabs]').forEach(tabsEl => {
    const buttons = tabsEl.querySelectorAll('[data-tab-btn]');
    const panels = tabsEl.querySelectorAll('[data-tab-panel]');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tabBtn;
        buttons.forEach(b => b.classList.toggle('is-active', b === btn));
        panels.forEach(p => {
          const isActive = p.dataset.tabPanel === target;
          p.classList.toggle('is-active', isActive);
          const slider = p.querySelector('[data-product-slider]');
          if (isActive) {
            if (slider && slider.dataset.sliderReady !== 'true') {
              initProductSlider(slider);
            }
            slider?._sliderReset?.();
          } else {
            slider?._sliderStop?.();
          }
        });
      });
    });
  });

  /* ── Accordions ── */
  document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('[data-accordion-item]');
      const isOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('[data-accordion-item]').forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });

  document.querySelectorAll('[data-faq-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.faq-item');
      item.classList.toggle('is-open');
    });
  });

  /* ── Collection filters ── */
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filters = document.querySelector('.collection-filters');
  const filterOverlay = document.querySelector('[data-filter-overlay]');
  const filterClose = document.querySelector('[data-filter-close]');
  const filterForm = document.getElementById('CollectionFiltersForm');

  const openFilters = () => {
    filters?.classList.add('is-open');
    filterOverlay?.classList.add('is-visible');
    filterOverlay?.setAttribute('aria-hidden', 'false');
    filterToggle?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeFilters = () => {
    filters?.classList.remove('is-open');
    filterOverlay?.classList.remove('is-visible');
    filterOverlay?.setAttribute('aria-hidden', 'true');
    filterToggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  filterToggle?.addEventListener('click', () => {
    if (filters?.classList.contains('is-open')) {
      closeFilters();
    } else {
      openFilters();
    }
  });

  filterClose?.addEventListener('click', closeFilters);
  filterOverlay?.addEventListener('click', closeFilters);

  if (filters?.classList.contains('is-open')) {
    filterToggle?.setAttribute('aria-expanded', 'true');
  }

  filterForm?.querySelectorAll('input[type="checkbox"]').forEach(input => {
    input.addEventListener('change', () => filterForm.submit());
  });

  const sortSelect = document.querySelector('[data-collection-sort]');
  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ── Quick add ── */
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      await fetch(window.theme.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      updateCartCount();
      if (window.theme.cartDrawerEnabled) openCart();
      btn.textContent = 'Added!';
      setTimeout(() => {
        btn.textContent = originalText || window.theme?.products?.quickAdd || 'Quick add';
        btn.disabled = false;
      }, 1500);
    } catch {
      btn.textContent = 'Error';
      btn.disabled = false;
    }
  });

  /* ── Product recommendations & recently viewed ── */
  const RECENTLY_VIEWED_KEY = 'suzeri_recently_viewed';

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  function formatCardMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return `$${(Number(cents) / 100).toFixed(2)}`;
  }

  function buildJsProductCard(product) {
    const img = product.featured_image || product.images?.[0];
    const imgSrc = typeof img === 'string' ? img : img?.src || '';
    const quickAddLabel = window.theme?.products?.quickAdd || 'Quick add';
    const quickViewLabel = window.theme?.products?.quickView || 'Quick view';
    const variant = product.variants?.find(v => v.available) || product.variants?.[0];
    const variantId = variant?.id;
    let priceHtml = formatCardMoney(product.price);

    if (product.compare_at_price > product.price) {
      priceHtml = `<span class="product-card__price--sale">${formatCardMoney(product.price)}</span><span class="product-card__price--compare">${formatCardMoney(product.compare_at_price)}</span>`;
    }

    const quickAdd =
      product.available && variantId
        ? `<button type="button" class="btn btn--quick-add" data-quick-add data-variant-id="${variantId}">${quickAddLabel}</button>`
        : '';

    return `
      <div class="product-card" data-product-card data-product-handle="${escapeHtml(product.handle)}">
        <div class="product-card__media">
          <a href="${product.url}" class="product-card__media-link">
            ${
              imgSrc
                ? `<img src="${imgSrc}" alt="${escapeHtml(product.title)}" loading="lazy" class="product-card__image product-card__image--primary">`
                : '<div class="product-card__placeholder"></div>'
            }
          </a>
          <div class="product-card__actions">
            <button type="button" class="btn btn--quick-view" data-quick-view data-product-handle="${escapeHtml(product.handle)}">${quickViewLabel}</button>
            ${quickAdd}
          </div>
        </div>
        <div class="product-card__info">
          <a href="${product.url}" class="product-card__title">${escapeHtml(product.title)}</a>
          <p class="product-card__price">${priceHtml}</p>
        </div>
      </div>`;
  }

  function trackRecentlyViewed(product) {
    if (!product?.id || !product?.handle) return;
    let items = [];

    try {
      items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch {
      items = [];
    }

    items = items.filter(item => item.id !== product.id);
    items.unshift({ id: product.id, handle: product.handle });
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items.slice(0, 12)));
  }

  function getProductSliderSettingsFromSection(section) {
    return {
      columnsDesktop: section?.dataset.columnsDesktop || '4',
      columnsTablet: section?.dataset.columnsTablet || '3',
      columnsMobile: section?.dataset.columnsMobile || '2',
      loop: section?.dataset.sliderLoop !== 'false',
      autoplay: section?.dataset.sliderAutoplay !== 'false',
      speed: (parseInt(section?.dataset.sliderSpeed, 10) || 5) * 1000,
      showArrows: section?.dataset.sliderArrows !== 'false'
    };
  }

  function mountProductSlider(container, settings, cards) {
    if (!container || !cards?.length) return null;

    const {
      columnsDesktop,
      columnsTablet,
      columnsMobile,
      loop,
      autoplay,
      speed,
      showArrows
    } = settings;

    container.innerHTML = '';

    const slider = document.createElement('div');
    slider.className = 'product-slider';
    slider.dataset.productSlider = '';
    slider.dataset.autoplay = autoplay ? 'true' : 'false';
    slider.dataset.loop = loop ? 'true' : 'false';
    slider.dataset.speed = String(speed);
    slider.dataset.columnsDesktop = String(columnsDesktop);
    slider.dataset.columnsTablet = String(columnsTablet);
    slider.dataset.columnsMobile = String(columnsMobile);

    if (showArrows) {
      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'product-slider__arrow product-slider__arrow--prev';
      prev.dataset.productPrev = '';
      prev.setAttribute('aria-label', 'Previous products');
      prev.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M15 18l-6-6 6-6"/></svg>';
      slider.appendChild(prev);
    }

    const viewport = document.createElement('div');
    viewport.className = 'product-slider__viewport';

    const track = document.createElement('div');
    track.className = 'product-slider__track';
    track.dataset.productTrack = '';
    track.style.setProperty('--product-columns-desktop', columnsDesktop);
    track.style.setProperty('--product-columns-tablet', columnsTablet);
    track.style.setProperty('--product-columns-mobile', columnsMobile);

    cards.forEach(card => {
      const slide = document.createElement('div');
      slide.className = 'product-slider__slide';
      slide.dataset.productSlide = '';
      slide.appendChild(card);
      track.appendChild(slide);
    });

    viewport.appendChild(track);
    slider.appendChild(viewport);

    if (showArrows) {
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'product-slider__arrow product-slider__arrow--next';
      next.dataset.productNext = '';
      next.setAttribute('aria-label', 'Next products');
      next.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 18l6-6-6-6"/></svg>';
      slider.appendChild(next);
    }

    container.appendChild(slider);
    initProductSlider(slider);
    return slider;
  }

  async function loadProductRecommendations(productId) {
    const section = document.querySelector('[data-product-recommendations]');
    const target = section?.querySelector('[data-product-recommendations-results]');
    if (!section || !target || !window.theme?.routes?.product_recommendations_url) return;

    const url = new URL(window.theme.routes.product_recommendations_url, window.location.origin);
    url.searchParams.set('section_id', 'product-recommendations');
    url.searchParams.set('product_id', productId);
    url.searchParams.set('limit', section.dataset.limit || '4');
    url.searchParams.set('intent', 'related');

    try {
      const res = await fetch(url.toString());
      if (!res.ok) return;

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fetchedSlider = doc.querySelector('[data-product-slider]');

      if (fetchedSlider) {
        target.innerHTML = fetchedSlider.outerHTML;
        const slider = target.querySelector('[data-product-slider]');
        if (slider) {
          slider.dataset.sliderReady = 'false';
          initProductSlider(slider);
        }
      } else if (!target.querySelector('[data-product-slider]') && !target.querySelector('.product-card')) {
        section.hidden = true;
      }
    } catch {
      /* keep Liquid fallback slider */
    }
  }

  async function renderRecentlyViewedProducts(currentProductId) {
    const section = document.querySelector('[data-recently-viewed]');
    const grid = section?.querySelector('[data-recently-viewed-grid]');
    if (!section || !grid) return;

    const limit = parseInt(section.dataset.recentlyLimit, 10) || 4;
    let items = [];

    try {
      items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch {
      items = [];
    }

    items = items.filter(item => item.id !== currentProductId).slice(0, limit);
    if (!items.length) {
      section.hidden = true;
      document.querySelector('[data-product-tab="recent"]')?.setAttribute('hidden', '');
      return;
    }

    document.querySelector('[data-product-tab="recent"]')?.removeAttribute('hidden');

    try {
      const products = await Promise.all(
        items.map(item =>
          fetch(`/products/${item.handle}.js`)
            .then(res => (res.ok ? res.json() : null))
            .catch(() => null)
        )
      );

      const valid = products.filter(Boolean);
      if (!valid.length) {
        section.hidden = true;
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.innerHTML = valid.map(buildJsProductCard).join('');
      const cards = [...wrapper.querySelectorAll('.product-card')];
      const settings = getProductSliderSettingsFromSection(section);
      settings.showArrows = section.dataset.sliderArrows !== 'false';
      mountProductSlider(grid, settings, cards);
      section.hidden = false;
    } catch {
      section.hidden = true;
    }
  }

  /* ── Product page ── */
  const productPage = document.querySelector('[data-product-page]');
  const productForm = document.querySelector('[data-product-form]');

  function formatProductMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return `$${(Number(cents) / 100).toFixed(2)}`;
  }

  function getVariantImage(product, variant) {
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (variant?.featured_image?.url) return variant.featured_image.url;
    if (variant?.image_id) {
      const image = product.images.find(img => img.id === variant.image_id);
      if (image) return image.src;
    }
    return product.featured_image || product.images[0]?.src || '';
  }

  if (productPage && productForm) {
    const productJson = productPage.querySelector('[data-product-json]');
    const product = productJson ? JSON.parse(productJson.textContent) : null;
    const variantInput = productForm.querySelector('[data-variant-id]');
    const mainImage = productPage.querySelector('[data-product-main-image]');
    const priceEl = productPage.querySelector('[data-price]');
    const compareEl = productPage.querySelector('[data-compare-price]');
    const badgeEl = productPage.querySelector('[data-discount-badge]');
    const addBtn = productForm.querySelector('[data-add-to-cart]');
    const stickyBar = document.querySelector('[data-product-sticky]');
    const stickyAdd = document.querySelector('[data-sticky-add]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const atcBlock = productForm.querySelector('[data-product-atc]');

    let selectedOptions = product
      ? product.options.map((_, i) => product.variants[0][`option${i + 1}`])
      : [];

    function findVariant(options = selectedOptions) {
      if (!product) return null;
      return product.variants.find(variant =>
        options.every((value, index) => variant[`option${index + 1}`] === value)
      );
    }

    function variantExistsForOptions(options) {
      return product.variants.some(variant =>
        options.every((value, index) => variant[`option${index + 1}`] === value)
      );
    }

    function updateOptionAvailability() {
      productPage.querySelectorAll('[data-product-option]').forEach(optionEl => {
        const optIndex = parseInt(optionEl.dataset.optionIndex, 10);

        optionEl.querySelectorAll('[data-product-option-value]').forEach(btn => {
          const testOptions = [...selectedOptions];
          testOptions[optIndex] = btn.dataset.value;
          const variant = findVariant(testOptions);
          const exists = variantExistsForOptions(testOptions);
          const available = !!variant?.available;

          btn.disabled = !exists || !available;
          btn.classList.toggle('is-unavailable', !exists || !available);
        });
      });
    }

    function updateOptionLabels() {
      productPage.querySelectorAll('[data-product-option]').forEach(optionEl => {
        const index = parseInt(optionEl.dataset.optionIndex, 10);
        const label = optionEl.querySelector('[data-option-value-label]');
        if (label && selectedOptions[index]) label.textContent = selectedOptions[index];
      });
    }

    function updateVariantUI(variant) {
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatProductMoney(variant.price);

      if (compareEl && badgeEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatProductMoney(variant.compare_at_price);
          compareEl.hidden = false;
          const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          badgeEl.textContent = `${discount}% OFF`;
          badgeEl.hidden = false;
          priceEl?.classList.add('product-info__price--sale');
        } else {
          compareEl.hidden = true;
          badgeEl.hidden = true;
          priceEl?.classList.remove('product-info__price--sale');
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? (window.theme?.strings?.addToCart || 'Add to cart')
          : (window.theme?.strings?.soldOut || 'Sold out');
      }

      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (stickyPrice) stickyPrice.textContent = formatProductMoney(variant.price);

      const imageSrc = getVariantImage(product, variant);
      if (mainImage && imageSrc) {
        mainImage.src = imageSrc;
        mainImage.removeAttribute('srcset');
      }

      productPage.querySelectorAll('[data-product-option-value]').forEach(btn => {
        const optIndex = parseInt(btn.dataset.optionIndex, 10);
        btn.classList.toggle('is-selected', selectedOptions[optIndex] === btn.dataset.value);
      });

      productPage.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        const imageId = variant.featured_image?.id || variant.image_id;
        const matchesVariant = imageId && String(thumb.dataset.imageId) === String(imageId);
        thumb.classList.toggle('is-active', matchesVariant);
      });

      productPage.querySelectorAll('[data-gallery-item]').forEach(item => {
        const imageId = variant.featured_image?.id || variant.image_id;
        const matchesVariant = imageId && String(item.dataset.imageId) === String(imageId);
        item.classList.toggle('is-active', matchesVariant);
        if (matchesVariant) {
          item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });

      updateOptionAvailability();
    }

    productPage.querySelectorAll('[data-product-option-value]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;

        const optIndex = parseInt(btn.dataset.optionIndex, 10);
        selectedOptions[optIndex] = btn.dataset.value;
        updateOptionLabels();

        const previewImage = btn.dataset.imageUrl;
        if (previewImage && mainImage) {
          mainImage.src = previewImage;
          mainImage.removeAttribute('srcset');
        } else if (previewImage) {
          productPage.querySelectorAll('[data-gallery-item]').forEach(item => {
            const img = item.querySelector('img');
            const matches = img && (img.currentSrc === previewImage || img.src === previewImage);
            item.classList.toggle('is-active', matches);
            if (matches) item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          });
        }

        let variant = findVariant();
        if (!variant) {
          variant = product.variants.find(v => v[`option${optIndex + 1}`] === btn.dataset.value && v.available)
            || product.variants.find(v => v[`option${optIndex + 1}`] === btn.dataset.value);
        }
        if (variant) updateVariantUI(variant);
        else updateOptionAvailability();
      });
    });

    productPage.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        if (mainImage && src) {
          mainImage.src = src;
          mainImage.removeAttribute('srcset');
        }
        productPage.querySelectorAll('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const initialVariantId = parseInt(variantInput?.value, 10);
    const initialVariant = product.variants.find(v => v.id === initialVariantId) || product.variants.find(v => v.available) || product.variants[0];
    if (initialVariant) {
      selectedOptions = product.options.map((_, i) => initialVariant[`option${i + 1}`]);
      updateOptionLabels();
      updateVariantUI(initialVariant);
    }

    if (stickyBar && atcBlock) {
      stickyBar.hidden = false;
      const observer = new IntersectionObserver(entries => {
        const visible = entries[0]?.isIntersecting;
        stickyBar.classList.toggle('is-visible', !visible);
      }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
      observer.observe(atcBlock);
    }

    const descriptionEl = productPage.querySelector('[data-product-description]');
    const descriptionToggle = productPage.querySelector('[data-description-toggle]');
    if (descriptionEl && descriptionToggle) {
      const needsToggle = descriptionEl.scrollHeight > descriptionEl.clientHeight + 8;
      if (!needsToggle) {
        descriptionToggle.hidden = true;
        descriptionEl.classList.remove('is-truncated');
      }

      descriptionToggle.addEventListener('click', () => {
        const expanded = descriptionEl.classList.toggle('is-expanded');
        descriptionEl.classList.toggle('is-truncated', !expanded);
        descriptionToggle.textContent = expanded
          ? (window.theme?.products?.readLess || 'Read less')
          : (window.theme?.products?.readMore || 'Read more');
        descriptionToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    document.querySelector('[data-more-payments-toggle]')?.addEventListener('click', e => {
      const panel = document.getElementById('ProductMorePayments');
      if (!panel) return;
      const expanded = panel.hidden;
      panel.hidden = !expanded;
      e.currentTarget.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    document.querySelectorAll('[data-product-tab]').forEach(tabBtn => {
      tabBtn.addEventListener('click', () => {
        const target = tabBtn.dataset.productTab;
        document.querySelectorAll('[data-product-tab]').forEach(btn => {
          const active = btn.dataset.productTab === target;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        document.querySelectorAll('[data-product-tab-panel]').forEach(panel => {
          const active = panel.dataset.productTabPanel === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });

    stickyAdd?.addEventListener('click', () => {
      productForm.requestSubmit();
    });

    if (product) {
      trackRecentlyViewed(product);
      loadProductRecommendations(product.id);
      renderRecentlyViewedProducts(product.id);
    }
  }

  productForm?.addEventListener('submit', async e => {
    e.preventDefault();
    const submitBtn = productForm.querySelector('[data-add-to-cart]') || productForm.querySelector('[type="submit"]');
    if (!submitBtn || submitBtn.disabled) return;

    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';

    try {
      const res = await fetch(window.theme.routes.cart_add, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(productForm)
      });
      if (!res.ok) throw new Error('Add failed');
      updateCartCount();
      if (window.theme.cartDrawerEnabled) openCart();
      submitBtn.textContent = 'Added to cart';
      setTimeout(() => {
        submitBtn.textContent = originalText;
        const variantId = parseInt(productForm.querySelector('[data-variant-id]')?.value, 10);
        const productData = productPage?.querySelector('[data-product-json]');
        if (productData && variantId) {
          const parsed = JSON.parse(productData.textContent);
          const variant = parsed.variants.find(v => v.id === variantId);
          submitBtn.disabled = variant ? !variant.available : false;
        } else {
          submitBtn.disabled = false;
        }
      }, 1500);
    } catch {
      submitBtn.textContent = 'Error';
      setTimeout(() => {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }, 1500);
    }
  });

  /* ── Cart helpers ── */
  const cartStrings = window.theme?.cartStrings || {};

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function formatShippingMessage(template, amountCents) {
    const amountText = formatMoney(amountCents);
    return String(template || 'You are {{ amount }} away from free shipping')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountText)
      .replace(/\{\{\s*amount\s*\}\}/g, amountText);
  }

  function getShippingState(cart) {
    const threshold = parseFloat(window.theme.freeShippingThreshold || 89) * 100;
    const remaining = threshold - cart.total_price;
    const progress = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    if (cart.item_count === 0) {
      return { message: '', qualified: false, progress: 0, show: false };
    }
    if (remaining <= 0) {
      return { message: cartStrings.qualified || 'Congratulations! Your order qualifies for free shipping', qualified: true, progress: 100, show: true };
    }
    return {
      message: formatShippingMessage(cartStrings.remaining, remaining),
      qualified: false,
      progress,
      show: true
    };
  }

  function renderCartLineHTML(item, compact) {
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="cart-line__variant">${item.variant_title}</p>`
      : '';
    const unitPrice = compact ? '' : `<p class="cart-line__unit-price">${formatMoney(item.final_price)}</p>`;
    const image = item.image
      ? `<img src="${item.image}" alt="${item.product_title}" width="100" height="100" loading="lazy">`
      : '<span class="cart-line__placeholder" aria-hidden="true"></span>';

    return `
      <div class="cart-line" data-cart-line data-line-key="${item.key}">
        <a href="${item.url}" class="cart-line__image">${image}</a>
        <div class="cart-line__details">
          <a href="${item.url}" class="cart-line__title">${item.product_title}</a>
          ${variant}
          ${unitPrice}
        </div>
        <div class="cart-line__actions">
          <div class="cart-qty" data-cart-qty>
            <button type="button" class="cart-qty__btn" data-qty-minus aria-label="${cartStrings.decrease || 'Decrease'}">−</button>
            <input type="number" class="cart-qty__input" value="${item.quantity}" min="0" aria-label="${cartStrings.quantity || 'Quantity'}" data-qty-input>
            <button type="button" class="cart-qty__btn" data-qty-plus aria-label="${cartStrings.increase || 'Increase'}">+</button>
          </div>
          <p class="cart-line__total" data-line-total>${formatMoney(item.final_line_price)}</p>
          <button type="button" class="cart-line__remove" data-line-remove aria-label="${cartStrings.remove || 'Remove'}">${cartStrings.remove || 'Remove'}</button>
        </div>
      </div>`;
  }

  function updateShippingBars(cart) {
    const state = getShippingState(cart);
    document.querySelectorAll('[data-cart-shipping]').forEach(el => {
      if (!state.show) {
        el.hidden = true;
        el.textContent = '';
        return;
      }
      el.hidden = false;
      el.textContent = state.message;
    });

    document.querySelectorAll('[data-cart-shipping-bar]').forEach(bar => {
      const text = bar.querySelector('[data-cart-shipping-text]');
      const track = bar.querySelector('.cart-shipping-bar__track');
      const fill = bar.querySelector('.cart-shipping-bar__fill');
      if (!state.show) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;
      bar.classList.toggle('cart-shipping-bar--qualified', state.qualified);
      if (text) text.textContent = state.message;
      if (fill) fill.style.width = `${state.progress}%`;
      if (track) track.hidden = state.qualified;
    });
  }

  function updateCartSubtotals(cart) {
    document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
      el.textContent = formatMoney(cart.total_price);
    });
    document.querySelectorAll('[data-cart-drawer-count]').forEach(el => {
      el.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
    });
  }

  async function changeCartLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
    if (!res.ok) throw new Error('Cart update failed');
    return res.json();
  }

  async function updateCartNote(note) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note })
    });
  }

  function bindCartLineEvents(container) {
    container?.addEventListener('click', async e => {
      const line = e.target.closest('[data-cart-line]');
      if (!line) return;
      const key = line.dataset.lineKey;
      const input = line.querySelector('[data-qty-input]');
      let quantity = parseInt(input?.value, 10) || 0;

      if (e.target.closest('[data-qty-minus]')) {
        quantity = Math.max(0, quantity - 1);
      } else if (e.target.closest('[data-qty-plus]')) {
        quantity += 1;
      } else if (e.target.closest('[data-line-remove]')) {
        quantity = 0;
      } else {
        return;
      }

      e.preventDefault();
      line.classList.add('is-updating');
      try {
        const cart = await changeCartLine(key, quantity);
        await updateCartCountFromCart(cart);
        if (cart.item_count === 0 && document.querySelector('[data-cart-page]')) {
          window.location.reload();
          return;
        }
        refreshCartDrawerFromCart(cart);
        updateCartPageFromCart(cart);
      } catch {
        line.classList.remove('is-updating');
      }
    });

    container?.addEventListener('change', async e => {
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;
      const line = input.closest('[data-cart-line]');
      const key = line?.dataset.lineKey;
      if (!key) return;
      const quantity = parseInt(input.value, 10) || 0;
      try {
        const cart = await changeCartLine(key, quantity);
        await updateCartCountFromCart(cart);
        if (cart.item_count === 0 && document.querySelector('[data-cart-page]')) {
          window.location.reload();
          return;
        }
        refreshCartDrawerFromCart(cart);
        updateCartPageFromCart(cart);
      } catch {
        input.value = input.defaultValue;
      }
    });
  }

  async function updateCartCount() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    await updateCartCountFromCart(cart);
    return cart;
  }

  async function updateCartCountFromCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    });
  }

  function refreshCartDrawerFromCart(cart) {
    const container = document.querySelector('[data-cart-items]');
    const footer = document.querySelector('[data-cart-footer]');
    if (!container) return;

    updateShippingBars(cart);
    updateCartSubtotals(cart);

    if (cart.item_count === 0) {
      container.innerHTML = `
        <div class="cart-drawer__empty">
          <p>${cartStrings.empty || 'Your cart is empty'}</p>
          <a href="/collections/all" class="btn btn--primary">${cartStrings.continueShopping || 'Continue shopping'}</a>
        </div>`;
      footer?.setAttribute('hidden', '');
      return;
    }

    footer?.removeAttribute('hidden');
    container.innerHTML = cart.items.map(item => renderCartLineHTML(item, true)).join('');
  }

  async function refreshCartDrawer() {
    const cart = await updateCartCount();
    refreshCartDrawerFromCart(cart);
  }

  function updateCartPageFromCart(cart) {
    if (!document.querySelector('[data-cart-page]')) return;

    updateShippingBars(cart);
    updateCartSubtotals(cart);

    cart.items.forEach(item => {
      const line = document.querySelector(`[data-line-key="${item.key}"]`);
      if (!line) return;
      const input = line.querySelector('[data-qty-input]');
      const total = line.querySelector('[data-line-total]');
      if (input) input.value = item.quantity;
      if (total) total.textContent = formatMoney(item.final_line_price);
      line.classList.remove('is-updating');
    });

    document.querySelectorAll('[data-cart-line]').forEach(line => {
      const exists = cart.items.some(item => item.key === line.dataset.lineKey);
      if (!exists) line.remove();
    });

    const countEl = document.querySelector('.cart-page__count');
    if (countEl) {
      countEl.textContent = cart.item_count === 1 ? '1 item' : `${cart.item_count} items`;
    }
  }

  bindCartLineEvents(document.querySelector('[data-cart-items]'));
  bindCartLineEvents(document.querySelector('[data-cart-lines]'));

  document.querySelector('[data-cart-note]')?.addEventListener('blur', e => {
    updateCartNote(e.target.value);
  });

  async function initCartState() {
    try {
      const cart = await updateCartCount();
      updateShippingBars(cart);
      if (document.querySelector('[data-cart-page]')) {
        updateCartSubtotals(cart);
      }
    } catch {
      /* cart fetch failed — keep server-rendered values */
    }
  }

  initCartState();

  /* ── Hero slider ── */
  document.querySelectorAll('[data-hero-slider]').forEach(slider => {
    const slides = slider.querySelectorAll('[data-hero-slide]');
    const dots = slider.querySelectorAll('[data-hero-dot]');
    const prevBtn = slider.querySelector('[data-hero-prev]');
    const nextBtn = slider.querySelector('[data-hero-next]');
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed, 10) || 5000;
    let current = 0;
    let timer = null;

    if (slides.length <= 1) return;

    function pauseVideos(slide) {
      slide?.querySelectorAll('video').forEach(video => {
        video.pause();
      });
    }

    function playVideos(slide) {
      slide?.querySelectorAll('video').forEach(video => {
        video.currentTime = 0;
        video.play().catch(() => {});
      });
    }

    function goTo(index) {
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const isActive = i === current;
        slide.classList.toggle('is-active', isActive);
        if (!isActive) pauseVideos(slide);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      playVideos(slides[current]);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay) return;
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    prevBtn?.addEventListener('click', () => { prev(); startAutoplay(); });
    nextBtn?.addEventListener('click', () => { next(); startAutoplay(); });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.heroDot, 10));
        startAutoplay();
      });
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    let touchStartX = 0;
    slider.addEventListener('touchstart', e => {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    slider.addEventListener('touchend', e => {
      const diff = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? prev() : next();
      }
      startAutoplay();
    }, { passive: true });

    playVideos(slides[0]);
    startAutoplay();
  });

  /* ── Category slider ── */
  document.querySelectorAll('[data-category-slider]').forEach(section => {
    const track = section.querySelector('[data-category-track]');
    const slides = [...track.querySelectorAll('[data-category-slide]:not([data-clone])')];
    const allSlides = [...track.querySelectorAll('[data-category-slide]')];
    const prevBtn = section.querySelector('[data-category-prev]');
    const nextBtn = section.querySelector('[data-category-next]');
    const autoplay = section.dataset.autoplay === 'true';
    const loop = section.dataset.loop === 'true';
    const speed = parseInt(section.dataset.speed, 10) || 4000;
    let index = 0;
    let timer = null;
    let slideStep = 0;
    let visibleCount = 4;

    if (slides.length === 0) return;

    function getVisibleCount() {
      const w = window.innerWidth;
      if (w <= 749) return parseInt(section.dataset.columnsMobile, 10) || 2;
      if (w <= 989) return parseInt(section.dataset.columnsTablet, 10) || 3;
      return parseInt(section.dataset.columnsDesktop, 10) || 4;
    }

    function measure() {
      visibleCount = getVisibleCount();
      const first = allSlides[0];
      if (!first) return;
      const trackStyles = getComputedStyle(track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 16);
      slideStep = first.offsetWidth + gap;
    }

    function setPosition(animate) {
      track.style.transition = animate ? 'transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform = `translateX(-${index * slideStep}px)`;
    }

    function goNext() {
      if (slides.length <= visibleCount) return;
      index += 1;
      setPosition(true);

      if (loop && index >= slides.length) {
        setTimeout(() => {
          index = 0;
          setPosition(false);
        }, 560);
      } else if (!loop && index > slides.length - visibleCount) {
        setTimeout(() => {
          index = 0;
          setPosition(false);
        }, 560);
      }
    }

    function goPrev() {
      if (slides.length <= visibleCount) return;
      if (index === 0 && loop) {
        index = slides.length;
        setPosition(false);
        requestAnimationFrame(() => {
          index -= 1;
          setPosition(true);
        });
        return;
      }
      index = Math.max(0, index - 1);
      setPosition(true);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || slides.length <= visibleCount) return;
      timer = setInterval(goNext, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    prevBtn?.addEventListener('click', () => { goPrev(); startAutoplay(); });
    nextBtn?.addEventListener('click', () => { goNext(); startAutoplay(); });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    window.addEventListener('resize', () => {
      measure();
      setPosition(false);
    });

    measure();
    setPosition(false);
    startAutoplay();
  });

  /* ── Product slider ── */
  function ensureProductSliderClones(section) {
    const track = section.querySelector('[data-product-track]');
    if (!track || section.dataset.loop !== 'true') return;

    const existingClones = track.querySelectorAll('[data-product-slide][data-clone]');
    if (existingClones.length > 0) return;

    const slides = [...track.querySelectorAll('[data-product-slide]:not([data-clone])')];
    if (slides.length <= 1) return;

    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('product-slider__slide--clone');
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      track.appendChild(clone);
    });
  }

  function initProductSlider(section) {
    if (section.dataset.sliderReady === 'true') return;

    ensureProductSliderClones(section);

    const track = section.querySelector('[data-product-track]');
    if (!track) return;

    const slides = [...track.querySelectorAll('[data-product-slide]:not([data-clone])')];
    const allSlides = [...track.querySelectorAll('[data-product-slide]')];
    const prevBtn = section.querySelector('[data-product-prev]');
    const nextBtn = section.querySelector('[data-product-next]');
    const autoplay = section.dataset.autoplay === 'true';
    const loop = section.dataset.loop === 'true';
    const speed = parseInt(section.dataset.speed, 10) || 4000;
    let index = 0;
    let timer = null;
    let slideStep = 0;
    let visibleCount = 4;
    let isAnimating = false;

    if (slides.length === 0) return;

    section.dataset.sliderReady = 'true';

    function getVisibleCount() {
      const w = window.innerWidth;
      if (w <= 749) return parseInt(section.dataset.columnsMobile, 10) || 2;
      if (w <= 989) return parseInt(section.dataset.columnsTablet, 10) || 3;
      return parseInt(section.dataset.columnsDesktop, 10) || 4;
    }

    function isActivePanel() {
      const panel = section.closest('[data-tab-panel]');
      return !panel || panel.classList.contains('is-active');
    }

    function measure() {
      visibleCount = getVisibleCount();
      const first = allSlides.find(slide => slide.offsetWidth > 0) || allSlides[0];
      if (!first) return false;
      const trackStyles = getComputedStyle(track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 16);
      slideStep = first.offsetWidth + gap;
      return slideStep > 0;
    }

    function setPosition(animate) {
      track.style.transition = animate ? 'transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform = `translateX(-${index * slideStep}px)`;
    }

    function maxIndex() {
      return Math.max(0, slides.length - visibleCount);
    }

    function canScroll() {
      if (loop && slides.length > 1) return true;
      return slides.length > visibleCount;
    }

    function goNext() {
      if (!canScroll() || isAnimating || slideStep <= 0) return;
      isAnimating = true;
      index += 1;
      setPosition(true);

      if (loop && index >= slides.length) {
        setTimeout(() => {
          index = 0;
          setPosition(false);
          isAnimating = false;
        }, 560);
        return;
      }

      if (!loop && index > maxIndex()) {
        index = maxIndex();
        setPosition(true);
      }

      setTimeout(() => { isAnimating = false; }, 560);
    }

    function goPrev() {
      if (!canScroll() || isAnimating || slideStep <= 0) return;
      isAnimating = true;

      if (index === 0 && loop) {
        index = slides.length;
        setPosition(false);
        requestAnimationFrame(() => {
          index -= 1;
          setPosition(true);
          setTimeout(() => { isAnimating = false; }, 560);
        });
        return;
      }

      index = Math.max(0, index - 1);
      setPosition(true);
      setTimeout(() => { isAnimating = false; }, 560);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || !canScroll() || !isActivePanel() || slideStep <= 0) return;
      timer = setInterval(goNext, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    section._sliderStop = stopAutoplay;
    section._sliderReset = () => {
      index = 0;
      requestAnimationFrame(() => {
        if (measure()) {
          setPosition(false);
          startAutoplay();
        }
      });
    };

    prevBtn?.addEventListener('click', () => { goPrev(); startAutoplay(); });
    nextBtn?.addEventListener('click', () => { goNext(); startAutoplay(); });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    window.addEventListener('resize', () => {
      if (measure()) {
        index = Math.min(index, loop ? slides.length - 1 : maxIndex());
        setPosition(false);
      }
    });

    if (measure()) {
      setPosition(false);
      startAutoplay();
    } else {
      section._sliderReset();
    }
  }

  /* ── Review slider ── */
  function ensureReviewSliderClones(section) {
    const track = section.querySelector('[data-review-track]');
    if (!track || section.dataset.loop !== 'true') return;
    if (track.querySelector('[data-clone]')) return;

    const slides = [...track.querySelectorAll('[data-review-slide]:not([data-clone])')];
    if (slides.length <= 1) return;

    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('review-slider__slide--clone');
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  function initReviewSlider(section) {
    if (section.dataset.sliderReady === 'true') return;

    ensureReviewSliderClones(section);

    const track = section.querySelector('[data-review-track]');
    if (!track) return;

    const slides = [...track.querySelectorAll('[data-review-slide]:not([data-clone])')];
    const allSlides = [...track.querySelectorAll('[data-review-slide]')];
    const prevBtn = section.querySelector('[data-review-prev]');
    const nextBtn = section.querySelector('[data-review-next]');
    const autoplay = section.dataset.autoplay === 'true';
    const loop = section.dataset.loop === 'true';
    const speed = parseInt(section.dataset.speed, 10) || 5000;
    let index = 0;
    let timer = null;
    let slideStep = 0;
    let visibleCount = 3;
    let isAnimating = false;

    if (slides.length === 0) return;
    section.dataset.sliderReady = 'true';

    function getVisibleCount() {
      const w = window.innerWidth;
      if (w <= 749) return parseInt(section.dataset.columnsMobile, 10) || 1;
      if (w <= 989) return parseInt(section.dataset.columnsTablet, 10) || 2;
      return parseInt(section.dataset.columnsDesktop, 10) || 3;
    }

    function measure() {
      visibleCount = getVisibleCount();
      const first = allSlides.find(slide => slide.offsetWidth > 0) || allSlides[0];
      if (!first) return false;
      const trackStyles = getComputedStyle(track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 20);
      slideStep = first.offsetWidth + gap;
      return slideStep > 0;
    }

    function setPosition(animate) {
      track.style.transition = animate ? 'transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform = `translateX(-${index * slideStep}px)`;
    }

    function maxIndex() {
      return Math.max(0, slides.length - visibleCount);
    }

    function canScroll() {
      if (loop && slides.length > 1) return true;
      return slides.length > visibleCount;
    }

    function goNext() {
      if (!canScroll() || isAnimating || slideStep <= 0) return;
      isAnimating = true;
      index += 1;
      setPosition(true);

      if (loop && index >= slides.length) {
        setTimeout(() => {
          index = 0;
          setPosition(false);
          isAnimating = false;
        }, 560);
        return;
      }

      if (!loop && index > maxIndex()) {
        index = maxIndex();
        setPosition(true);
      }

      setTimeout(() => { isAnimating = false; }, 560);
    }

    function goPrev() {
      if (!canScroll() || isAnimating || slideStep <= 0) return;
      isAnimating = true;

      if (index === 0 && loop) {
        index = slides.length;
        setPosition(false);
        requestAnimationFrame(() => {
          index -= 1;
          setPosition(true);
          setTimeout(() => { isAnimating = false; }, 560);
        });
        return;
      }

      index = Math.max(0, index - 1);
      setPosition(true);
      setTimeout(() => { isAnimating = false; }, 560);
    }

    function startAutoplay() {
      if (timer) clearInterval(timer);
      if (!autoplay || !canScroll() || slideStep <= 0) return;
      timer = setInterval(goNext, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    prevBtn?.addEventListener('click', () => { goPrev(); startAutoplay(); });
    nextBtn?.addEventListener('click', () => { goNext(); startAutoplay(); });
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    window.addEventListener('resize', () => {
      if (measure()) {
        index = Math.min(index, loop ? slides.length - 1 : maxIndex());
        setPosition(false);
      }
    });

    function bootSlider() {
      if (measure()) {
        setPosition(false);
        startAutoplay();
        return true;
      }
      return false;
    }

    section._sliderReset = () => {
      ensureReviewSliderClones(section);
      index = Math.min(index, loop ? slides.length - 1 : maxIndex());
      bootSlider();
    };

    section._sliderStop = stopAutoplay;

    if (!bootSlider()) {
      requestAnimationFrame(() => {
        if (!bootSlider()) setTimeout(() => bootSlider(), 350);
      });
    }
  }

  function prepareReviewSlider(section) {
    if (section.dataset.sliderReady === 'true') {
      section._sliderReset?.();
      return;
    }
    initReviewSlider(section);
  }

  /* ── Instagram slider ── */
  function ensureInstagramSliderClones(section) {
    const track = section.querySelector('[data-instagram-track]');
    if (!track || section.dataset.loop !== 'true') return;
    if (track.querySelector('[data-clone]')) return;

    const slides = [...track.querySelectorAll('[data-instagram-slide]:not([data-clone])')];
    if (slides.length <= 1) return;

    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('instagram-slider__slide--clone');
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  function initInstagramSlider(section) {
    if (section.dataset.sliderReady === 'true') return;

    ensureInstagramSliderClones(section);

    const track = section.querySelector('[data-instagram-track]');
    if (!track) return;

    const slides = [...track.querySelectorAll('[data-instagram-slide]:not([data-clone])')];
    const allSlides = [...track.querySelectorAll('[data-instagram-slide]')];
    const prevBtn = section.querySelector('[data-instagram-prev]');
    const nextBtn = section.querySelector('[data-instagram-next]');
    const autoplay = section.dataset.autoplay === 'true';
    const loop = section.dataset.loop === 'true';
    const speed = parseInt(section.dataset.speed, 10) || 5000;
    let index = 0;
    let timer = null;
    let slideStep = 0;
    let visibleCount = 6;
    let isAnimating = false;

    if (slides.length === 0) return;
    section.dataset.sliderReady = 'true';

    function getVisibleCount() {
      const w = window.innerWidth;
      if (w <= 749) return parseInt(section.dataset.columnsMobile, 10) || 2;
      if (w <= 989) return parseInt(section.dataset.columnsTablet, 10) || 3;
      return parseInt(section.dataset.columnsDesktop, 10) || 6;
    }

    function measure() {
      visibleCount = getVisibleCount();
      const first = allSlides.find(slide => slide.offsetWidth > 0) || allSlides[0];
      if (!first) return false;
      const trackStyles = getComputedStyle(track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 12);
      slideStep = first.offsetWidth + gap;
      return slideStep > 0;
    }

    function setPosition(animate) {
      track.style.transition = animate ? 'transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform = `translateX(-${index * slideStep}px)`;
    }

    function maxIndex() {
      return Math.max(0, slides.length - visibleCount);
    }

    function canScroll() {
      if (loop && slides.length > 1) return true;
      return slides.length > visibleCount;
    }

    function goNext() {
      if (!canScroll() || isAnimating || slideStep <= 0) return;
      isAnimating = true;
      index += 1;
      setPosition(true);

      if (loop && index >= slides.length) {
        setTimeout(() => {
          index = 0;
          setPosition(false);
          isAnimating = false;
        }, 560);
        return;
      }

      if (!loop && index > maxIndex()) {
        index = maxIndex();
        setPosition(true);
      }

      setTimeout(() => { isAnimating = false; }, 560);
    }

    function goPrev() {
      if (!canScroll() || isAnimating || slideStep <= 0) return;
      isAnimating = true;

      if (index === 0 && loop) {
        index = slides.length;
        setPosition(false);
        requestAnimationFrame(() => {
          index -= 1;
          setPosition(true);
          setTimeout(() => { isAnimating = false; }, 560);
        });
        return;
      }

      index = Math.max(0, index - 1);
      setPosition(true);
      setTimeout(() => { isAnimating = false; }, 560);
    }

    function startAutoplay() {
      if (timer) clearInterval(timer);
      if (!autoplay || !canScroll() || slideStep <= 0) return;
      timer = setInterval(goNext, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    prevBtn?.addEventListener('click', () => { goPrev(); startAutoplay(); });
    nextBtn?.addEventListener('click', () => { goNext(); startAutoplay(); });
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    window.addEventListener('resize', () => {
      if (measure()) {
        index = Math.min(index, loop ? slides.length - 1 : maxIndex());
        setPosition(false);
      }
    });

    function bootSlider() {
      if (measure()) {
        setPosition(false);
        startAutoplay();
        return true;
      }
      return false;
    }

    section._sliderReset = () => {
      ensureInstagramSliderClones(section);
      index = Math.min(index, loop ? slides.length - 1 : maxIndex());
      bootSlider();
    };

    section._sliderStop = stopAutoplay;

    if (!bootSlider()) {
      requestAnimationFrame(() => {
        if (!bootSlider()) setTimeout(() => bootSlider(), 350);
      });
    }
  }

  function prepareInstagramSlider(section) {
    if (section.dataset.sliderReady === 'true') {
      section._sliderReset?.();
      return;
    }
    initInstagramSlider(section);
  }

  function initThemeSliders(root = document) {
    root.querySelectorAll('[data-product-slider]').forEach(section => {
      if (section.dataset.sliderReady !== 'true') initProductSlider(section);
      else section._sliderReset?.();
    });
    root.querySelectorAll('[data-review-slider]').forEach(prepareReviewSlider);
    root.querySelectorAll('[data-instagram-slider]').forEach(prepareInstagramSlider);
  }

  initThemeSliders();

  document.addEventListener('shopify:section:load', e => initThemeSliders(e.target));
  document.addEventListener('shopify:section:reorder', () => initThemeSliders());
  document.addEventListener('shopify:block:select', () => {
    document.querySelectorAll('[data-review-slider], [data-instagram-slider]').forEach(section => {
      section._sliderReset?.();
    });
  });

  window.addEventListener('load', () => {
    document.querySelectorAll('[data-review-slider], [data-instagram-slider], [data-product-slider]').forEach(section => {
      section._sliderReset?.();
    });
  });

  /* ── Review submission form ── */
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-review-form]');
    if (!form) return;

    const rating = form.querySelector('[data-review-rating]')?.value;
    const product = form.querySelector('[data-review-product]')?.value?.trim();
    const bodyField = form.querySelector('[name="contact[body]"]');
    if (!bodyField) return;

    const reviewText = bodyField.value.trim();
    const parts = [
      '--- Customer Review Submission ---',
      rating ? `Rating: ${rating}/5` : '',
      product ? `Product: ${product}` : '',
      '',
      reviewText
    ].filter((line, i, arr) => line !== '' || i === arr.length - 2);

    bodyField.value = parts.join('\n');
  });

  /* ── Product card swatches ── */
  document.addEventListener('click', e => {
    const swatch = e.target.closest('[data-swatch]');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const card = swatch.closest('[data-product-card]');
    if (!card) return;

    card.querySelectorAll('[data-swatch]').forEach(s => s.classList.toggle('is-active', s === swatch));
    card.classList.add('has-swatch-selected');

    const imageUrl = swatch.dataset.imageUrl;
    const primaryImage = card.querySelector('[data-product-image]');
    if (imageUrl && primaryImage) {
      primaryImage.src = imageUrl;
      primaryImage.removeAttribute('srcset');
    }

    const quickAdd = card.querySelector('[data-quick-add]');
    if (quickAdd && swatch.dataset.variantId) {
      quickAdd.dataset.variantId = swatch.dataset.variantId;
    }
  });

  /* ── Quick view modal ── */
  const quickViewModal = document.querySelector('[data-quick-view-modal]');
  const quickViewContent = document.querySelector('[data-quick-view-content]');
  const colorOptionNames = ['color', 'colour', 'metal', 'material', 'finish'];

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    const format = window.theme?.moneyFormat || '${{amount}}';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(Number(cents) / 100))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function isColorOption(name) {
    const n = name.toLowerCase();
    return colorOptionNames.some(keyword => n.includes(keyword));
  }

  function getSwatchColor(value) {
    const v = value.toLowerCase();
    const map = {
      silver: '#c8c8c8',
      'sterling silver': '#c8c8c8',
      'white gold': '#c8c8c8',
      white: '#c8c8c8',
      gold: '#d4af37',
      'yellow gold': '#d4af37',
      'rose gold': '#d8897a',
      'pink gold': '#d8897a',
      black: '#333333',
      blue: '#5b7fc7',
      green: '#6fae7a',
      red: '#c45c5c'
    };
    return map[v] || '#dddddd';
  }

  function closeQuickView() {
    quickViewModal?.classList.remove('is-open');
    quickViewModal?.setAttribute('aria-hidden', 'true');
    if (!cartDrawer?.classList.contains('is-open') && !searchModal?.classList.contains('is-open') && !menuDrawer?.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  }

  function findVariant(product, selectedOptions) {
    return product.variants.find(variant =>
      selectedOptions.every((value, index) => variant[`option${index + 1}`] === value)
    );
  }

  function getVariantImage(product, variant) {
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (variant?.image_id && Array.isArray(product.images)) {
      const image = product.images.find(img => typeof img === 'object' && img.id === variant.image_id);
      if (image?.src) return image.src;
    }

    const firstImage = Array.isArray(product.images) ? product.images[0] : null;
    if (typeof firstImage === 'string') return firstImage;
    return firstImage?.src || product.featured_image || '';
  }

  function renderQuickView(product) {
    if (!quickViewContent) return;

    const initialVariant = product.variants.find(variant => variant.available) || product.variants[0];
    const selectedOptions = product.options.map((opt, i) => initialVariant[`option${i + 1}`]);
    let selectedVariant = findVariant(product, selectedOptions) || initialVariant;

    function updateView() {
      selectedVariant = findVariant(product, selectedOptions) || selectedVariant;
      const imageEl = quickViewContent.querySelector('[data-qv-image]');
      const priceEl = quickViewContent.querySelector('[data-qv-price]');
      const addBtn = quickViewContent.querySelector('[data-qv-add]');

      if (imageEl) {
        imageEl.src = getVariantImage(product, selectedVariant);
        imageEl.alt = product.title;
      }

      if (priceEl) {
        const price = formatMoney(selectedVariant.price);
        const compare = selectedVariant.compare_at_price > selectedVariant.price
          ? formatMoney(selectedVariant.compare_at_price)
          : '';
        priceEl.innerHTML = compare
          ? `<span class="quick-view__price--sale">${price}</span><span class="quick-view__price--compare">${compare}</span>`
          : price;
      }

      if (addBtn) {
        addBtn.dataset.variantId = selectedVariant.id;
        addBtn.disabled = !selectedVariant.available;
        addBtn.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
      }

      quickViewContent.querySelectorAll('[data-qv-swatch]').forEach(btn => {
        const optIndex = parseInt(btn.dataset.optionIndex, 10);
        btn.classList.toggle('is-active', selectedOptions[optIndex] === btn.dataset.value);
      });

      quickViewContent.querySelectorAll('[data-qv-select]').forEach(select => {
        const optIndex = parseInt(select.dataset.optionIndex, 10);
        select.value = selectedOptions[optIndex];
      });
    }

    const optionsHtml = product.options.map((option, optIndex) => {
      if (isColorOption(option.name)) {
        const swatches = option.values.map(value => {
          const variant = product.variants.find(v => v[`option${optIndex + 1}`] === value);
          const imageSrc = getVariantImage(product, variant);
          const color = getSwatchColor(value);
          const inner = imageSrc
            ? `<img src="${imageSrc.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/i, '_80x80$1$2')}" alt="${value}">`
            : `<span style="display:block;width:100%;height:100%;border-radius:50%;background:${color}"></span>`;
          return `<button type="button" class="quick-view__swatch" data-qv-swatch data-option-index="${optIndex}" data-value="${value}" title="${value}">${inner}</button>`;
        }).join('');
        return `<div class="quick-view__option"><p class="quick-view__option-label">${option.name}</p><div class="quick-view__swatches">${swatches}</div></div>`;
      }

      const options = option.values.map(value =>
        `<option value="${value}">${value}</option>`
      ).join('');
      return `<div class="quick-view__option"><label class="quick-view__option-label">${option.name}</label><select class="quick-view__select" data-qv-select data-option-index="${optIndex}">${options}</select></div>`;
    }).join('');

    const imageSrc = getVariantImage(product, selectedVariant);

    quickViewContent.innerHTML = `
      <div class="quick-view">
        <div class="quick-view__media">
          <img src="${imageSrc}" alt="${product.title}" data-qv-image>
        </div>
        <div class="quick-view__details">
          <h2 class="quick-view__title">${product.title}</h2>
          <p class="quick-view__price" data-qv-price>${formatMoney(selectedVariant.price)}</p>
          <div class="quick-view__options">${optionsHtml}</div>
          <div class="quick-view__actions">
            <button type="button" class="btn btn--primary" data-qv-add data-variant-id="${selectedVariant.id}">Add to cart</button>
            <a href="/products/${product.handle}" class="quick-view__link">View full details</a>
          </div>
        </div>
      </div>
    `;

    quickViewContent.querySelectorAll('[data-qv-swatch]').forEach(btn => {
      btn.addEventListener('click', () => {
        const optIndex = parseInt(btn.dataset.optionIndex, 10);
        selectedOptions[optIndex] = btn.dataset.value;
        updateView();
      });
    });

    quickViewContent.querySelectorAll('[data-qv-select]').forEach(select => {
      select.addEventListener('change', () => {
        const optIndex = parseInt(select.dataset.optionIndex, 10);
        selectedOptions[optIndex] = select.value;
        updateView();
      });
    });

    updateView();

    quickViewContent.querySelector('[data-qv-add]')?.addEventListener('click', async e => {
      const button = e.currentTarget;
      const variantId = button.dataset.variantId;
      if (!variantId || button.disabled) return;

      button.textContent = 'Adding...';
      button.disabled = true;

      try {
        await fetch(window.theme.routes.cart_add, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        updateCartCount();
        if (window.theme.cartDrawerEnabled) openCart();
        button.textContent = 'Added!';
        setTimeout(() => {
          button.textContent = 'Add to cart';
          button.disabled = false;
        }, 1500);
      } catch {
        button.textContent = 'Error';
        button.disabled = false;
      }
    });
  }

  function openQuickView(handle) {
    if (!quickViewModal || !handle) return;

    quickViewModal.classList.add('is-open');
    quickViewModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (quickViewContent) {
      quickViewContent.innerHTML = '<div class="quick-view-modal__loading">Loading...</div>';
    }

    fetch(`/products/${encodeURIComponent(handle)}.js`, {
      headers: { Accept: 'application/json' }
    })
      .then(res => {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(product => renderQuickView(product))
      .catch(() => {
        if (quickViewContent) {
          quickViewContent.innerHTML = '<div class="quick-view-modal__loading">Unable to load product.</div>';
        }
      });
  }

  document.addEventListener('click', e => {
    const quickViewBtn = e.target.closest('[data-quick-view]');
    if (quickViewBtn) {
      e.preventDefault();
      openQuickView(quickViewBtn.dataset.productHandle);
    }
  });

  document.querySelectorAll('[data-quick-view-close]').forEach(btn => {
    btn.addEventListener('click', closeQuickView);
  });

  /* ── Customer account pages ── */
  const loginPanel = document.querySelector('[data-login-panel]');
  const recoverPanel = document.querySelector('[data-recover-panel]');
  const showRecoverBtn = document.querySelector('[data-show-recover]');
  const showLoginBtn = document.querySelector('[data-show-login]');

  showRecoverBtn?.addEventListener('click', () => {
    loginPanel?.setAttribute('hidden', '');
    recoverPanel?.removeAttribute('hidden');
  });

  showLoginBtn?.addEventListener('click', () => {
    recoverPanel?.setAttribute('hidden', '');
    loginPanel?.removeAttribute('hidden');
  });

  if (window.location.hash === '#recover') {
    showRecoverBtn?.click();
  }

  document.querySelectorAll('.customer-address-form').forEach(form => {
    const countrySelect = form.querySelector('[name="address[country]"]');
    const provinceSelect = form.querySelector('[name="address[province]"]');

    if (countrySelect && provinceSelect && window.Shopify?.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector(countrySelect.id, provinceSelect.id, {
        hideElement: provinceSelect.id
      });
    }
  });

  document.querySelectorAll('[data-address-edit]').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-address-edit');
      const panel = document.getElementById(`EditAddress-${id}`);
      panel?.removeAttribute('hidden');
      panel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-address-cancel]').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.customer-address-form-wrap')?.setAttribute('hidden', '');
    });
  });

  document.querySelectorAll('[data-address-delete]').forEach(btn => {
    btn.addEventListener('click', e => {
      const message = window.theme?.customer?.deleteConfirm || 'Are you sure you want to delete this address?';
      if (!window.confirm(message)) {
        e.preventDefault();
      }
    });
  });

  /* ── Escape key closes modals ── */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeCart();
      closeSearch();
      closeQuickView();
      closeMenuDrawer();
    }
  });
})();
